export const DAVIVIENDA = {
  Header: 'TÉRMINOS Y CONDICIONES – BENEFICIOS EN TRAVEL PAGANDO CON DAVIVIENDA',
  Body: [
    {
      Title: null,
      Paragraphs: [
        `Por medio del presente documento se dan a conocer los términos y condiciones de la 
        campaña denominada “BENEFICIOS EN TRAVEL PAGANDO CON DAVIVIENDA” (en adelante la “Campaña”). 
        La participación en la Campaña constituye la aceptación total e incondicional de los presentes 
        Términos y Condiciones, los cuales resultan definitivos y vinculantes para los 
        Usuarios/Consumidores participantes, que cumplan con los requisitos aquí dispuestos. `,
        'PRIMERA. - Territorio: Campaña válida únicamente para órdenes realizadas a través de los Sistemas Rappi Travel.',
        'SEGUNDA. - Vigencia: Campaña válida del 22 de febrero de 2022 a las 12:01 a.m. al 04 de marzo de 2022 a las 11:59 p.m. ',
        `TERCERA. – Sistemas Rappi Travel: Los Sistemas Rappi Travel incluyen, pero sin limitarse a, 
        la Plataforma Rappi, la sección de “Rappi Travel” dentro de la página web www.rappi.com, 
        el Botón Rappi Travel, entre otros.`,
        'CUARTA – Tarjetas Participantes Davivienda: Participarán las siguientes tarjetas de crédito del banco Davivienda S.A.:',
        '·         Tarjeta de Crédito Davivienda Diners',
        '·         Tarjeta de Crédito Davivienda Visa',
        '·         Tarjeta de Crédito Davivienda Mastercard',
        '·         Tarjeta de Crédito Davivienda Diners marca compartida',
        '·         Tarjeta de Crédito Davivienda Visa marca compartida',
        '·         Tarjeta de Crédito Davivienda Mastercard marca compartida',
        `QUINTA. - Beneficio: Los Usuarios/Consumidores que realicen órdenes a través de los 
        Sistemas Rappi Travel por un valor igual o superior a un millón quinientos mil pesos 
        M/CTE ($1.500.000) y paguen con las Tarjetas Participantes Davivienda difiriendo el 
        pago a cuotas de tres (3), seis (6) y doce (12) meses, recibirán un descuento de 
        cien por ciento (100%) sobre el valor cobrando por concepto de tasa de interés.`,
        `Se aclara que no serán tenidas en cuenta las compras que sean diferidas a una periodicidad 
        de cuotas diferentes a tres (3), seis (6) y doce (12) meses. `,
        `SEXTA. - Condiciones y Restricciones: Podrán participar gratuitamente todas las personas
         naturales que sean Usuarios/Consumidores de los Sistemas Rappi Travel que residan en 
         el territorio colombiano y que cumplan las siguientes condiciones:`,
        `-         Campaña válida únicamente para los Usuarios/Consumidores que se encuentren al 
        día con sus pagos y/u obligaciones con el banco Davivienda S.A. y que la Tarjeta 
        Participante Davivienda no presente ningún bloqueo.`,
        `-         Los Usuarios/Consumidores deberán realizar órdenes a través de los 
        Sistemas Rappi Travel por un valor igual o superior a un millón quinientos mil pesos M/CTE ($1.500.000). 
        Se aclara que el Beneficio no aplicará para ordenes por un valor inferior.`,
        `−        Campaña válida para todas las órdenes que cumplan las condiciones y 
        restricciones establecidas en los presentes Términos y Condiciones.`,
        `−        El Beneficio obtenido en virtud de la presente Campaña no es acumulable 
        con otras promociones exhibidas en los Sistemas Rappi Travel. `,
        `−        Si posterior a la fecha de compra se cambia el plazo definido para la 
        transacción que tiene el Beneficio o para todas las transacciones vigentes de 
        la Tarjeta Participante Davivienda, se perderá el Beneficio y se aplicará la 
        tasa de interés vigente del día en que solicitó el cambio de plazo.`,
        `−        Se aclara que no serán tenidas en cuentas las órdenes pagadas con la 
        tarjeta de crédito denominada “RappiCard”.`,
        'SÉPTIMA. - Medio de Pago: Campaña válida para órdenes pagadas únicamente con las Tarjetas Participantes Davivienda.',
        `OCTAVA. - Tratamiento de Datos Personales: El Usuario/Consumidor presta su consentimiento, 
        libre, expreso e informado para que su información personal sea utilizada para ser
         contactado con ocasión a esta Campaña.`,
        `NOVENA. - Validez de la Información: El Usuario/Consumidor reconoce y acepta que la 
        información proporcionada y registrada en los Sistemas Rappi Travel, es veraz y fidedigna, 
        haciéndose completamente responsable por su falsedad.`,
        `DÉCIMA. - Modificaciones e Interpretación: Travel Mustache se reserva el derecho de cancelar 
        órdenes si detecta intención de fraude. Rappi se reserva el derecho de rechazar y 
        cancelar cualquier orden que, por sus características, Rappi determine que no aplica 
        para el beneficio de la presente Campaña, sin previo aviso al Usuario/Consumidor.`,
        `DÉCIMA PRIMERA. - Declaración: El Usuario/Consumidor reconoce y acepta que quién exhibe, 
        ofrece, promociona y comercializa los productos adquiridos a través de los Sistemas 
        Rappi Travel son los Aliados Comerciales. Travel Mustache opera únicamente como 
        intermediario entre los Usuarios/Consumidores y los Prestadores, entendiéndose
         que Travel Moustache no es el Prestador de los Servicios Turísticos. Por lo anterior, 
         el Usuario/Consumidor que contrata los Servicios Turísticos a través de Travel Moustache, 
         lo hace directamente con el Prestador.`,
        `Se aclara que los presentes Términos y Condiciones se encuentran sujetos a los 
        Términos y Condiciones de Uso de RappiTravel que se encuentran en la siguiente 
        dirección electrónica: https://travel.rappi.com.co/terms `
      ]
    },
  ]
};
